import { createActionConst } from '../../../utils/action.utils';

const AGENDA_ITEM_NAMESPACE = 'TASK';

export const STORE_AGENDA_ITEM = createActionConst(AGENDA_ITEM_NAMESPACE, 'STORE_AGENDA_ITEM');
export const CLEAR_AGENDA_ITEM = createActionConst(AGENDA_ITEM_NAMESPACE, 'CLEAR_AGENDA_ITEM');
